var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: {
        modalClass: "ss-modal",
        btOkName: _vm.$t(
          "__.Components.parent.duplicacoes.list_vue_html.unificar"
        ),
        showAddNew: false,
      },
      on: { "selection-item": _vm.onUnificar },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.errors.first("clienteIdOrigem"),
                    expression: "errors.first('clienteIdOrigem')",
                  },
                ],
                staticClass: "form-group",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: {
                      for: "clienteIdOrigem",
                      title: _vm.$t("__.obrigatorio"),
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t(
                            "__.Components.parent.duplicacoes.list_vue_html.clienteOrigem"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("search-combo-component", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "clienteIdOrigem",
                    name: "clienteIdOrigem",
                    actionName: "Clientes",
                    addEditId: false,
                    addNew: false,
                    advancedSearch: true,
                    advancedSearchCampos: [
                      { campo: "text", descricao: "Nome" },
                      { campo: "cpf", descricao: "CNPJ/CPF" },
                    ],
                    customComboText: _vm.customComboTextCliente,
                    customView: true,
                    propDescription: "nome",
                    service: "Cliente",
                  },
                  model: {
                    value: _vm.clienteIdOrigem,
                    callback: function ($$v) {
                      _vm.clienteIdOrigem = $$v
                    },
                    expression: "clienteIdOrigem",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.errors.first("clienteIdDestino"),
                    expression: "errors.first('clienteIdDestino')",
                  },
                ],
                staticClass: "form-group",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: {
                      for: "clienteIdDestino",
                      title: _vm.$t("__.obrigatorio"),
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t(
                            "__.Components.parent.duplicacoes.list_vue_html.clienteDestino"
                          )
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("search-combo-component", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    id: "clienteIdDestino",
                    name: "clienteIdDestino",
                    actionName: "Clientes",
                    addEditId: false,
                    addNew: false,
                    advancedSearch: true,
                    advancedSearchCampos: [
                      { campo: "text", descricao: "Nome" },
                      { campo: "cpf", descricao: "CNPJ/CPF" },
                    ],
                    customComboText: _vm.customComboTextCliente,
                    customView: true,
                    propDescription: "nome",
                    service: "Cliente",
                  },
                  model: {
                    value: _vm.clienteIdDestino,
                    callback: function ($$v) {
                      _vm.clienteIdDestino = $$v
                    },
                    expression: "clienteIdDestino",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }